<div class="card p-mb-2">
  <h4>{{ 'CURRENT_ALLOWANCE' | translate }}</h4>
  <app-allowance-form [allowances]="readonlyAllowances"></app-allowance-form>
</div>

<div class="card p-mb-2">
  <h4>{{ 'EDIT_ALLOWANCE' | translate }}</h4>
  <app-allowance-form [allowances]="editableAllowances" [editable]="true">
    <div class="p-d-flex p-ai-center p-mt-2">
      <div class="p-mr-2">{{ 'STARTING_ON' | translate }}:</div>
      <div class="p-mr-2">
        <p-calendar
          inputId="time"
          [(ngModel)]="startingOn"
          dateFormat="dd.mm.yy"
          view="month"
          [showIcon]="true"
          [minDate]="minDate"
        ></p-calendar>
      </div>
      <button
        pButton
        class="w-6 p-t-right"
        type="button"
        [disabled]="!startingOn"
        label="{{ 'ACTION.SAVE' | translate }}"
        (click)="onEdit()"
      ></button>
    </div>
  </app-allowance-form>
</div>
